<div class="flex items-center justify-between relative">
  <!-- Mobile-only scroll affordance: a soft gradient fading into the strip's
       own colour, with a chevron on top, rather than a hard button shape that
       would compete with the tab pills. Hidden entirely once there is nothing
       left to scroll that way (canScrollLeft/canScrollRight), and hidden on
       desktop where the strip already fits without scrolling. -->
  <button
    *ngIf="canScrollLeft"
    type="button"
    class="tabs-scroll-fade tabs-scroll-fade--left md:hidden"
    (click)="scrollByAmount(-120)"
    aria-label="Scroll tabs left"
    i18n-aria-label="@@scrollTabsLeft"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div
    #scroller
    (scroll)="updateScrollState()"
    class="tabs-scroller flex gap-x-1.5 items-center justify-between bg-primary px-2 py-2 rounded-lg overflow-auto"
    role="group"
  >
    <ng-container *ngFor="let button of buttons">
      <button
        *ngIf="hasPermission(button.perms)"
        type="button"
        class="px-4 h-full whitespace-nowrap text-[11px] border-none transition-colors duration-150 hover:bg-white hover:text-primary/95"
        [ngClass]="button.isActive ? 'bg-white text-primary/95' : 'bg-primary text-white/95'"
        [disabled]="isDisabled"
        (click)="toggleActive(button.value)"
        [matTooltip]="button.name"
      >
        {{ button.name }}
      </button>
    </ng-container>
  </div>

  <button
    *ngIf="canScrollRight"
    type="button"
    class="tabs-scroll-fade tabs-scroll-fade--right md:hidden"
    (click)="scrollByAmount(120)"
    aria-label="Scroll tabs right"
    i18n-aria-label="@@scrollTabsRight"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
